const filters = {}

export default filters



// WEBPACK FOOTER //
// ./src/untils/filters.js